import React, { useState, useEffect } from "react";
import { FaBook, FaUserGraduate, FaBriefcase, FaMoneyBillWave, FaRobot, FaCertificate, FaLaptopCode, FaChartLine, FaSearch, FaStar, FaClock, FaGraduationCap, FaUsers, FaCheckCircle, FaTrophy, FaFire, FaArrowRight, FaHome, FaBookOpen } from "react-icons/fa";

const CompleteAcademyDashboard = () => {
  const [level, setLevel] = useState("");
  const [background, setBackground] = useState("");
  const [course, setCourse] = useState("");
  const [duration, setDuration] = useState("");
  const [details, setDetails] = useState(null);
  const [aiRecommendations, setAiRecommendations] = useState([]);

  // Comprehensive Course Database
  const courseDatabase = {
    school: {
      name: "School Level (Class 6-10)",
      courses: [
        {
          name: "AI & Coding Foundation",
          fee: { 3: 5000, 6: 9000, 9: 12000, 12: 15000 },
          internship: "Mini AI Project & App Development",
          highlights: ["Python Basics", "AI Fundamentals", "Scratch Programming", "Web Development"],
          placement: "Portfolio Building",
          rating: 4.8,
          enrolled: 1250
        },
        {
          name: "IIT/NEET Foundation Course",
          fee: { 3: 7000, 6: 12000, 9: 16000, 12: 20000 },
          internship: "STEM Lab Project & Research",
          highlights: ["PCM Strong Foundation", "Problem Solving", "Olympiad Prep", "Lab Skills"],
          placement: "School Topper Program",
          rating: 4.9,
          enrolled: 2100
        },
        {
          name: "Full Stack Development Junior",
          fee: { 3: 6000, 6: 10000, 9: 14000, 12: 17000 },
          internship: "Live Website Project",
          highlights: ["HTML/CSS/JS", "React Basics", "Database Intro", "Hosting"],
          placement: "Freelance Guidance",
          rating: 4.7,
          enrolled: 890
        }
      ]
    },
    plus2: {
      name: "+1 / +2 (11th & 12th)",
      courses: [
        {
          name: "IIT JEE Advanced Training",
          fee: { 3: 25000, 6: 45000, 9: 60000, 12: 75000 },
          internship: "Physics-AI Lab & Research Project",
          highlights: ["Advanced PCM", "Mock Tests", "IIT Alumni Mentorship", "Previous Year Analysis"],
          placement: "Top IIT Preparation",
          rating: 4.9,
          enrolled: 3500
        },
        {
          name: "NEET Complete Preparation",
          fee: { 3: 22000, 6: 40000, 9: 55000, 12: 70000 },
          internship: "Medical Research & Hospital Project",
          highlights: ["PCB Mastery", "Medical Terminology", "Clinical Skills", "Mock NEET Tests"],
          placement: "Top Medical College Prep",
          rating: 4.9,
          enrolled: 4200
        },
        {
          name: "CA Foundation & CPT",
          fee: { 3: 18000, 6: 32000, 9: 45000, 12: 55000 },
          internship: "Finance Analytics & Audit Project",
          highlights: ["Accounting", "Business Law", "Economics", "Taxation Basics"],
          placement: "CA Firm Internship",
          rating: 4.7,
          enrolled: 1800
        },
        {
          name: "Advanced AI & Machine Learning",
          fee: { 3: 20000, 6: 35000, 9: 48000, 12: 60000 },
          internship: "Real AI/ML Company Project",
          highlights: ["Python Advanced", "Neural Networks", "Deep Learning", "AI Ethics"],
          placement: "Tech Startup Internship",
          rating: 4.8,
          enrolled: 1500
        }
      ]
    },
    ug_science: {
      name: "UG - BSc (Science Background)",
      courses: [
        {
          name: "IIT JAM Physics/Chemistry/Maths",
          fee: { 3: 15000, 6: 27000, 9: 38000, 12: 48000 },
          internship: "Research Lab Project",
          highlights: ["Complete Syllabus", "Mock Tests", "IIT Faculty", "Research Papers"],
          placement: "IIT/NIT Preparation",
          rating: 4.8,
          enrolled: 950
        },
        {
          name: "Data Science & Analytics",
          fee: { 3: 30000, 6: 55000, 9: 75000, 12: 95000 },
          internship: "Industry Data Science Project",
          highlights: ["Python/R", "SQL", "Machine Learning", "Big Data"],
          placement: "100% Placement Support",
          rating: 4.9,
          enrolled: 2800
        },
        {
          name: "Full Stack Development",
          fee: { 3: 30000, 6: 52000, 9: 72000, 12: 90000 },
          internship: "Live Web Application Project",
          highlights: ["MERN Stack", "DevOps", "Cloud Computing", "Microservices"],
          placement: "Guaranteed Interview Calls",
          rating: 4.8,
          enrolled: 3200
        },
        {
          name: "AI & Deep Learning Engineer",
          fee: { 3: 35000, 6: 62000, 9: 85000, 12: 110000 },
          internship: "AI Product Development",
          highlights: ["TensorFlow", "PyTorch", "Computer Vision", "NLP"],
          placement: "Top Tech Companies",
          rating: 4.9,
          enrolled: 1900
        },
        {
          name: "Cyber Security & Ethical Hacking",
          fee: { 3: 28000, 6: 50000, 9: 68000, 12: 85000 },
          internship: "Security Audit Project",
          highlights: ["Network Security", "Penetration Testing", "Security Tools", "Certifications"],
          placement: "Security Analyst Roles",
          rating: 4.7,
          enrolled: 1400
        }
      ]
    },
    ug_commerce: {
      name: "UG - B.Com (Commerce Background)",
      courses: [
        {
          name: "CA Intermediate + Analytics",
          fee: { 3: 22000, 6: 40000, 9: 55000, 12: 70000 },
          internship: "CA Firm Real Audit Project",
          highlights: ["Advanced Accounting", "Taxation", "Audit", "Financial Management"],
          placement: "Big 4 Preparation",
          rating: 4.8,
          enrolled: 2100
        },
        {
          name: "Financial Analytics & FinTech",
          fee: { 3: 25000, 6: 45000, 9: 62000, 12: 78000 },
          internship: "FinTech Company Project",
          highlights: ["Excel/Power BI", "Financial Modeling", "Bloomberg Terminal", "Trading"],
          placement: "Banking & Finance Sector",
          rating: 4.7,
          enrolled: 1600
        },
        {
          name: "Digital Marketing & E-Commerce",
          fee: { 3: 15000, 6: 27000, 9: 38000, 12: 48000 },
          internship: "Live Marketing Campaign",
          highlights: ["SEO/SEM", "Social Media", "Google Ads", "Analytics"],
          placement: "Marketing Agencies",
          rating: 4.6,
          enrolled: 2300
        },
        {
          name: "Business Analytics & Data Visualization",
          fee: { 3: 28000, 6: 50000, 9: 68000, 12: 85000 },
          internship: "Corporate Analytics Project",
          highlights: ["Python/R for Business", "Tableau", "SQL", "Predictive Analytics"],
          placement: "Business Analyst Roles",
          rating: 4.8,
          enrolled: 1800
        }
      ]
    },
    ug_management: {
      name: "UG - BBA/BBM (Management Background)",
      courses: [
        {
          name: "MBA Entrance Complete (CAT/MAT/XAT)",
          fee: { 3: 18000, 6: 32000, 9: 45000, 12: 55000 },
          internship: "Corporate Strategy Project",
          highlights: ["Quantitative Aptitude", "Verbal Ability", "Logical Reasoning", "Mock Tests"],
          placement: "Top B-School Preparation",
          rating: 4.7,
          enrolled: 2500
        },
        {
          name: "HR Analytics & Management",
          fee: { 3: 20000, 6: 36000, 9: 50000, 12: 62000 },
          internship: "HR Department Real Project",
          highlights: ["HR Systems", "People Analytics", "Recruitment Tech", "Performance Management"],
          placement: "HR Manager Roles",
          rating: 4.6,
          enrolled: 1200
        },
        {
          name: "Product Management & Strategy",
          fee: { 3: 30000, 6: 55000, 9: 75000, 12: 95000 },
          internship: "Product Launch Project",
          highlights: ["Product Development", "Market Research", "Agile/Scrum", "User Experience"],
          placement: "Product Manager Roles",
          rating: 4.8,
          enrolled: 1100
        },
        {
          name: "Digital Business & E-Commerce",
          fee: { 3: 22000, 6: 40000, 9: 55000, 12: 68000 },
          internship: "E-Commerce Business Setup",
          highlights: ["Online Business Models", "Supply Chain", "Digital Payments", "Growth Hacking"],
          placement: "Startup Ecosystem",
          rating: 4.7,
          enrolled: 1400
        }
      ]
    },
    ug_engineering: {
      name: "UG - B.Tech/BE (Engineering)",
      courses: [
        {
          name: "Full Stack Development Pro",
          fee: { 3: 35000, 6: 62000, 9: 85000, 12: 105000 },
          internship: "Production-Level Application",
          highlights: ["MERN/MEAN Stack", "AWS/Azure", "Kubernetes", "System Design"],
          placement: "FAANG Preparation",
          rating: 4.9,
          enrolled: 4500
        },
        {
          name: "Cloud Computing & DevOps",
          fee: { 3: 32000, 6: 58000, 9: 78000, 12: 98000 },
          internship: "Cloud Infrastructure Project",
          highlights: ["AWS/Azure/GCP", "Docker", "CI/CD", "Infrastructure as Code"],
          placement: "Cloud Engineer Roles",
          rating: 4.8,
          enrolled: 2700
        },
        {
          name: "AI & Machine Learning Advanced",
          fee: { 3: 40000, 6: 72000, 9: 98000, 12: 125000 },
          internship: "AI Product Development",
          highlights: ["Deep Learning", "Computer Vision", "NLP", "MLOps"],
          placement: "AI Engineer - Top Companies",
          rating: 4.9,
          enrolled: 3100
        },
        {
          name: "Blockchain & Web3 Development",
          fee: { 3: 38000, 6: 68000, 9: 92000, 12: 115000 },
          internship: "DApp Development Project",
          highlights: ["Solidity", "Smart Contracts", "Ethereum", "DeFi"],
          placement: "Blockchain Developer",
          rating: 4.7,
          enrolled: 1300
        },
        {
          name: "Cyber Security Professional",
          fee: { 3: 35000, 6: 62000, 9: 85000, 12: 105000 },
          internship: "Security Operations Project",
          highlights: ["Ethical Hacking", "Security Operations", "Threat Intelligence", "Compliance"],
          placement: "Security Analyst/Engineer",
          rating: 4.8,
          enrolled: 1900
        },
        {
          name: "Data Engineering & Big Data",
          fee: { 3: 36000, 6: 65000, 9: 88000, 12: 110000 },
          internship: "Big Data Pipeline Project",
          highlights: ["Spark", "Hadoop", "Kafka", "Data Warehousing"],
          placement: "Data Engineer Roles",
          rating: 4.8,
          enrolled: 1600
        }
      ]
    },
    pg_science: {
      name: "PG - MSc/M.Tech (Science & Tech)",
      courses: [
        {
          name: "GATE Complete Preparation",
          fee: { 3: 20000, 6: 36000, 9: 50000, 12: 62000 },
          internship: "Research Lab Project",
          highlights: ["All Branches", "Mock Tests", "Previous Years", "Interview Prep"],
          placement: "PSU/IIT/Research Positions",
          rating: 4.9,
          enrolled: 3800
        },
        {
          name: "CSIR-UGC NET (Life/Physical/Chemical Sciences)",
          fee: { 3: 25000, 6: 45000, 9: 62000, 12: 78000 },
          internship: "Research Publication Support",
          highlights: ["Complete Syllabus", "Research Methodology", "Paper Writing", "Mock Tests"],
          placement: "Lectureship/JRF",
          rating: 4.8,
          enrolled: 2400
        },
        {
          name: "Advanced AI & Quantum Computing",
          fee: { 3: 40000, 6: 72000, 9: 98000, 12: 125000 },
          internship: "Quantum Computing Lab Project",
          highlights: ["Quantum Algorithms", "Qiskit", "Advanced AI", "Research Papers"],
          placement: "Research Scientist Roles",
          rating: 4.9,
          enrolled: 850
        },
        {
          name: "Research Methodology & PhD Preparation",
          fee: { 3: 22000, 6: 40000, 9: 55000, 12: 68000 },
          internship: "Research Paper Publication",
          highlights: ["Research Design", "Statistical Analysis", "Paper Writing", "PhD Guidance"],
          placement: "PhD Admissions Support",
          rating: 4.7,
          enrolled: 1100
        },
        {
          name: "MLOps & AI Engineering",
          fee: { 3: 38000, 6: 68000, 9: 92000, 12: 115000 },
          internship: "Production AI System",
          highlights: ["ML Pipeline", "Model Deployment", "Monitoring", "Scaling"],
          placement: "ML Engineer - Senior Roles",
          rating: 4.9,
          enrolled: 1400
        }
      ]
    },
    pg_management: {
      name: "PG - MBA/PGDM",
      courses: [
        {
          name: "Business Analytics & AI for MBA",
          fee: { 3: 35000, 6: 62000, 9: 85000, 12: 105000 },
          internship: "Corporate Consulting Project",
          highlights: ["Advanced Analytics", "AI for Business", "Strategy", "Leadership"],
          placement: "Management Consultant",
          rating: 4.8,
          enrolled: 1600
        },
        {
          name: "FinTech & Financial Engineering",
          fee: { 3: 38000, 6: 68000, 9: 92000, 12: 115000 },
          internship: "Investment Banking Project",
          highlights: ["Algorithmic Trading", "Risk Management", "Derivatives", "Portfolio Management"],
          placement: "Investment Banking/Finance",
          rating: 4.8,
          enrolled: 950
        },
        {
          name: "Executive Leadership Program",
          fee: { 3: 45000, 6: 82000, 9: 112000, 12: 140000 },
          internship: "Business Transformation Project",
          highlights: ["Strategic Management", "Change Leadership", "Innovation", "Global Business"],
          placement: "C-Suite/Senior Management",
          rating: 4.9,
          enrolled: 720
        }
      ]
    }
  };

  const durations = {
    3: { title: "Crash Course", desc: "Intensive training with Mini Internship" },
    6: { title: "Foundation Plus", desc: "Strong Foundation + Real Project Internship" },
    9: { title: "Advanced Training", desc: "Advanced Modules + Industry Internship" },
    12: { title: "Complete Mastery", desc: "Full Mastery + Live Project + Placement Support" }
  };

  useEffect(() => {
    if (level && (background || level === "school" || level === "plus2")) {
      const recommendations = generateAIRecommendations();
      setAiRecommendations(recommendations);
    }
  }, [level, background]);

  const generateAIRecommendations = () => {
    const categoryKey = background || level;
    const category = courseDatabase[categoryKey];
    if (!category) return [];
    
    return category.courses
      .sort((a, b) => b.rating - a.rating)
      .slice(0, 3)
      .map(c => c.name);
  };

  const handleSubmit = () => {
    if (course && duration) {
      const categoryKey = background || level;
      const category = courseDatabase[categoryKey];
      const selected = category.courses.find((c) => c.name === course);
      
      if (selected) {
        setDetails({
          ...selected,
          duration: duration,
          durationInfo: durations[duration],
          selectedFee: selected.fee[duration]
        });
      }
    }
  };

  const getBackgroundOptions = () => {
    if (level === "ug") {
      return [
        { value: "ug_science", label: "BSc - Science Background" },
        { value: "ug_commerce", label: "B.Com - Commerce Background" },
        { value: "ug_management", label: "BBA/BBM - Management" },
        { value: "ug_engineering", label: "B.Tech/BE - Engineering" }
      ];
    } else if (level === "pg") {
      return [
        { value: "pg_science", label: "MSc/M.Tech - Science & Technology" },
        { value: "pg_management", label: "MBA/PGDM - Management" }
      ];
    }
    return [];
  };

  const getCourses = () => {
    const categoryKey = background || level;
    return courseDatabase[categoryKey]?.courses || [];
  };

  return (
    <div className="bg-light" style={{ minHeight: '100vh' }}>
     
      {/* Hero Section */}
      <div className="bg-dark text-white py-5 my-5" style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}>
        <div className="container text-center py-4">
          <h1 className="display-4 fw-bold mb-3">Complete Training from School to Postgraduate</h1>
          <p className="lead mb-4">Job-Oriented Programs | Real Company Internships | 100% Placement Support</p>
          <div className="row justify-content-center g-4">
            <div className="col-md-3 col-sm-6">
              <div className="card bg-transparent border-light text-white">
                <div className="card-body">
                  <FaUsers className="fs-1 mb-2" />
                  <h3 className="fw-bold mb-0">25,000+</h3>
                  <small>Students</small>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-6">
              <div className="card bg-transparent border-light text-white">
                <div className="card-body">
                  <FaStar className="fs-1 mb-2" />
                  <h3 className="fw-bold mb-0">4.8</h3>
                  <small>Average Rating</small>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-6">
              <div className="card bg-transparent border-light text-white">
                <div className="card-body">
                  <FaTrophy className="fs-1 mb-2" />
                  <h3 className="fw-bold mb-0">95%</h3>
                  <small>Placement Rate</small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="container my-5">
        {/* Selection Card */}
        <div className="card shadow-lg border-0 rounded-4 mb-4" style={{ marginTop: '-50px' }}>
          <div className="card-body p-4 p-md-5">
            <div className="d-flex align-items-center mb-4">
              <div className="bg-primary text-white rounded-3 p-3 me-3">
                <FaRobot className="fs-3" />
              </div>
              <h2 className="fw-bold mb-0">Find Your Perfect Course</h2>
            </div>

            <div className="row g-3 mb-4">
              {/* Education Level */}
              <div className="col-md-6 col-lg-3">
                <label className="form-label fw-semibold">Select Education Level *</label>
                <select
                  className="form-select form-select-lg"
                  value={level}
                  onChange={(e) => {
                    setLevel(e.target.value);
                    setBackground("");
                    setCourse("");
                    setDuration("");
                    setDetails(null);
                  }}
                >
                  <option value="">--Choose Level--</option>
                  <option value="school">🎒 School (Class 6-10)</option>
                  <option value="plus2">📚 +1 / +2 (11th & 12th)</option>
                  <option value="ug">🎓 Undergraduate (UG)</option>
                  <option value="pg">👨‍🎓 Postgraduate (PG)</option>
                </select>
              </div>
              {/* Background Selection for UG/PG */}
              {(level === "ug" || level === "pg") && (
                <div className="col-md-6 col-lg-3">
                  <label className="form-label fw-semibold">Select Background *</label>
                  <select
                    className="form-select form-select-lg"
                    value={background}
                    onChange={(e) => {
                      setBackground(e.target.value);
                      setCourse("");
                      setDuration("");
                      setDetails(null);
                    }}
                  >
                    <option value="">--Choose Background--</option>
                    {getBackgroundOptions().map((opt, idx) => (
                      <option key={idx} value={opt.value}>{opt.label}</option>
                    ))}
                  </select>
                </div>
              )}

              {/* Course Selection */}
              <div className="col-md-6 col-lg-3">
                <label className="form-label fw-semibold">Select Course *</label>
                <select
                  className="form-select form-select-lg"
                  disabled={!level || ((level === "ug" || level === "pg") && !background)}
                  value={course}
                  onChange={(e) => {
                    setCourse(e.target.value);
                    setDuration("");
                    setDetails(null);
                  }}
                >
                  <option value="">--Choose Course--</option>
                  {getCourses().map((c, idx) => (
                    <option key={idx} value={c.name}>
                      {c.name} ⭐{c.rating}
                    </option>
                  ))}
                </select>
              </div>

              {/* Duration */}
              <div className="col-md-6 col-lg-3">
                <label className="form-label fw-semibold">Select Duration *</label>
                <select
                  className="form-select form-select-lg"
                  disabled={!course}
                  value={duration}
                  onChange={(e) => setDuration(e.target.value)}
                >
                  <option value="">--Choose Duration--</option>
                  <option value="3">⚡ 3 Months</option>
                  <option value="6">📈 6 Months</option>
                  <option value="9">🚀 9 Months</option>
                  <option value="12">🏆 1 Year</option>
                </select>
              </div>
            </div>

            {/* AI Recommendations */}
            {aiRecommendations.length > 0 && (
              <div className="alert alert-info border-0 mb-4" style={{ background: 'linear-gradient(135deg, #e0f2fe 0%, #bae6fd 100%)' }}>
                <div className="d-flex align-items-center mb-3">
                  <FaFire className="text-danger me-2 fs-5" />
                  <strong className="fs-5">🤖 AI Recommended Courses for You</strong>
                </div>
                <div className="d-flex flex-wrap gap-2">
                  {aiRecommendations.map((rec, idx) => (
                    <button
                      key={idx}
                      onClick={() => setCourse(rec)}
                      className="btn btn-outline-primary btn-sm rounded-pill"
                    >
                      {rec}
                    </button>
                  ))}
                </div>
              </div>
            )}

            <div className="text-center">
              <button
                onClick={handleSubmit}
                disabled={!duration}
                className="btn btn-primary btn-lg px-5 rounded-pill shadow"
              >
                <FaSearch className="me-2" /> Show Complete Details
              </button>
            </div>
          </div>
        </div>

        {/* Course Details */}
        {details && (
          <div className="card shadow-lg border-0 rounded-4 overflow-hidden">
            {/* Header */}
            <div className="card-header text-white py-4" style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}>
              <h3 className="fw-bold mb-3">{details.name}</h3>
              <div className="d-flex flex-wrap gap-3">
                <span><FaStar className="text-warning me-1" /> {details.rating} Rating</span>
                <span><FaUsers className="me-1" /> {details.enrolled} Students</span>
                <span><FaFire className="text-danger me-1" /> Trending</span>
              </div>
            </div>

            <div className="card-body p-4 p-md-5">
              {/* Key Metrics */}
              <div className="row g-4 mb-5">
                <div className="col-md-6 col-lg-3">
                  <div className="card border-primary bg-light h-100">
                    <div className="card-body text-center">
                      <FaClock className="text-primary fs-1 mb-3" />
                      <h6 className="text-muted mb-2">Duration</h6>
                      <h4 className="fw-bold text-primary">{details.duration} Months</h4>
                      <small className="text-muted">{details.durationInfo.desc}</small>
                    </div>
                  </div>
                </div>

                <div className="col-md-6 col-lg-3">
                  <div className="card border-success bg-light h-100">
                    <div className="card-body text-center">
                      <FaMoneyBillWave className="text-success fs-1 mb-3" />
                      <h6 className="text-muted mb-2">Course Fee</h6>
                      <h4 className="fw-bold text-success">₹{details.selectedFee}</h4>
                      <small className="text-muted">EMI Available</small>
                    </div>
                  </div>
                </div>

                <div className="col-md-6 col-lg-3">
                  <div className="card border-warning bg-light h-100">
                    <div className="card-body text-center">
                      <FaBriefcase className="text-warning fs-1 mb-3" />
                      <h6 className="text-muted mb-2">Internship</h6>
                      <p className="fw-bold text-warning small mb-1">{details.internship}</p>
                      <small className="text-muted">Real Project</small>
                    </div>
                  </div>
                </div>

                <div className="col-md-6 col-lg-3">
                  <div className="card border-danger bg-light h-100">
                    <div className="card-body text-center">
                      <FaCertificate className="text-danger fs-1 mb-3" />
                      <h6 className="text-muted mb-2">Certification</h6>
                      <p className="fw-bold text-danger small mb-1">{details.placement}</p>
                      <small className="text-muted">Industry Recognized</small>
                    </div>
                  </div>
                </div>
              </div>

              {/* What You'll Learn */}
              <div className="mb-5">
                <h4 className="fw-bold mb-4 d-flex align-items-center">
                  <FaChartLine className="text-primary me-2" /> What You'll Learn
                </h4>
                <div className="row g-3">
                  {details.highlights.map((highlight, idx) => (
                    <div key={idx} className="col-md-6">
                      <div className="d-flex align-items-center bg-light p-3 rounded-3">
                        <FaCheckCircle className="text-success fs-5 me-3 flex-shrink-0" />
                        <span className="fw-semibold">{highlight}</span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Program Benefits */}
              <div className="bg-light rounded-4 p-4 mb-5">
                <h4 className="fw-bold mb-4">{details.durationInfo.title} Program Benefits</h4>
                <div className="row g-3">
                  {details.duration === "3" && (
                    <>
                      <div className="col-md-6">
                        <div className="d-flex align-items-start">
                          <FaCheckCircle className="text-success mt-1 me-2 flex-shrink-0" />
                          <span>Intensive fast-track learning</span>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="d-flex align-items-start">
                          <FaCheckCircle className="text-success mt-1 me-2 flex-shrink-0" />
                          <span>Core concepts mastery</span>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="d-flex align-items-start">
                          <FaCheckCircle className="text-success mt-1 me-2 flex-shrink-0" />
                          <span>Mini project internship</span>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="d-flex align-items-start">
                          <FaCheckCircle className="text-success mt-1 me-2 flex-shrink-0" />
                          <span>Quick skill building</span>
                        </div>
                      </div>
                    </>
                  )}
                  {details.duration === "6" && (
                    <>
                      <div className="col-md-6">
                        <div className="d-flex align-items-start">
                          <FaCheckCircle className="text-success mt-1 me-2 flex-shrink-0" />
                          <span>Strong foundational training</span>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="d-flex align-items-start">
                          <FaCheckCircle className="text-success mt-1 me-2 flex-shrink-0" />
                          <span>Real industry project</span>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="d-flex align-items-start">
                          <FaCheckCircle className="text-success mt-1 me-2 flex-shrink-0" />
                          <span>Portfolio development</span>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="d-flex align-items-start">
                          <FaCheckCircle className="text-success mt-1 me-2 flex-shrink-0" />
                          <span>Interview preparation</span>
                        </div>
                      </div>
                    </>
                  )}
                  {details.duration === "9" && (
                    <>
                      <div className="col-md-6">
                        <div className="d-flex align-items-start">
                          <FaCheckCircle className="text-success mt-1 me-2 flex-shrink-0" />
                          <span>Advanced modules included</span>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="d-flex align-items-start">
                          <FaCheckCircle className="text-success mt-1 me-2 flex-shrink-0" />
                          <span>Live company internship</span>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="d-flex align-items-start">
                          <FaCheckCircle className="text-success mt-1 me-2 flex-shrink-0" />
                          <span>Multiple project experience</span>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="d-flex align-items-start">
                          <FaCheckCircle className="text-success mt-1 me-2 flex-shrink-0" />
                          <span>Industry mentorship</span>
                        </div>
                      </div>
                    </>
                  )}
                  {details.duration === "12" && (
                    <>
                      <div className="col-md-6">
                        <div className="d-flex align-items-start">
                          <FaCheckCircle className="text-success mt-1 me-2 flex-shrink-0" />
                          <span>Complete mastery program</span>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="d-flex align-items-start">
                          <FaCheckCircle className="text-success mt-1 me-2 flex-shrink-0" />
                          <span>Production-level projects</span>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="d-flex align-items-start">
                          <FaCheckCircle className="text-success mt-1 me-2 flex-shrink-0" />
                          <span>100% placement support</span>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="d-flex align-items-start">
                          <FaCheckCircle className="text-success mt-1 me-2 flex-shrink-0" />
                          <span>Resume & mock interviews</span>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="d-flex align-items-start">
                          <FaCheckCircle className="text-success mt-1 me-2 flex-shrink-0" />
                          <span>Industry connections</span>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="d-flex align-items-start">
                          <FaCheckCircle className="text-success mt-1 me-2 flex-shrink-0" />
                          <span>Lifetime career support</span>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>

              {/* Additional Features */}
              <div className="bg-light rounded-4 p-4 mb-5">
                <h4 className="fw-bold mb-4">Additional Features Included</h4>
                <div className="row g-3">
                  <div className="col-md-4">
                    <div className="d-flex align-items-center">
                      <FaLaptopCode className="text-primary fs-4 me-3" />
                      <span className="fw-semibold">Live Online Classes</span>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="d-flex align-items-center">
                      <FaBook className="text-primary fs-4 me-3" />
                      <span className="fw-semibold">Study Materials</span>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="d-flex align-items-center">
                      <FaUserGraduate className="text-primary fs-4 me-3" />
                      <span className="fw-semibold">Expert Mentors</span>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="d-flex align-items-center">
                      <FaCertificate className="text-primary fs-4 me-3" />
                      <span className="fw-semibold">Industry Certificate</span>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="d-flex align-items-center">
                      <FaBriefcase className="text-primary fs-4 me-3" />
                      <span className="fw-semibold">Job Assistance</span>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="d-flex align-items-center">
                      <FaChartLine className="text-primary fs-4 me-3" />
                      <span className="fw-semibold">Progress Tracking</span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Enrollment CTA */}
              <div className="card bg-success bg-opacity-10 border-success border-2 rounded-4">
                <div className="card-body p-4 text-center">
                  <h4 className="fw-bold text-success mb-3">🎉 Ready to Start Your Journey?</h4>
                  <p className="text-dark mb-4">
                    Limited seats available! Enroll now and get exclusive bonuses worth ₹10,000
                  </p>

                  <div className="d-flex flex-wrap justify-content-center gap-3 mb-4">
                    <button className="btn btn-success btn-lg px-4 rounded-pill shadow">
                      🚀 Enroll Now - ₹{details.selectedFee}
                    </button>
                    <button className="btn btn-outline-success btn-lg px-4 rounded-pill">
                      📞 Talk to Counselor
                    </button>
                  </div>

                  <div className="row g-3">
                    <div className="col-md-4">
                      <div className="card shadow-sm">
                        <div className="card-body">
                          <small className="text-muted d-block mb-1">Early Bird Offer</small>
                          <h5 className="fw-bold text-success mb-0">20% OFF</h5>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="card shadow-sm">
                        <div className="card-body">
                          <small className="text-muted d-block mb-1">EMI Available</small>
                          <h5 className="fw-bold text-primary mb-0">₹{Math.round(details.selectedFee / 12)}/mo</h5>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="card shadow-sm">
                        <div className="card-body">
                          <small className="text-muted d-block mb-1">Money Back</small>
                          <h5 className="fw-bold text-danger mb-0">7-Day Guarantee</h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="text-center mt-4">
                <button
                  onClick={() => setDetails(null)}
                  className="btn btn-link text-primary"
                >
                  ← Back to Course Selection
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Features Section */}
        {!details && (
          <div className="row g-4 mt-4">
            <div className="col-md-4">
              <div className="card border-0 shadow-sm h-100 hover-card">
                <div className="card-body text-center p-4">
                  <div className="bg-primary bg-opacity-10 rounded-circle d-inline-flex align-items-center justify-content-center mb-3" style={{ width: '80px', height: '80px' }}>
                    <FaRobot className="text-primary fs-1" />
                  </div>
                  <h5 className="fw-bold mb-3">AI-Powered Learning</h5>
                  <p className="text-muted">
                    Personalized course recommendations and adaptive learning paths tailored to your goals
                  </p>
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <div className="card border-0 shadow-sm h-100 hover-card">
                <div className="card-body text-center p-4">
                  <div className="bg-success bg-opacity-10 rounded-circle d-inline-flex align-items-center justify-content-center mb-3" style={{ width: '80px', height: '80px' }}>
                    <FaBriefcase className="text-success fs-1" />
                  </div>
                  <h5 className="fw-bold mb-3">Real Internships</h5>
                  <p className="text-muted">
                    Work on live company projects with hands-on industry experience and real-world exposure
                  </p>
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <div className="card border-0 shadow-sm h-100 hover-card">
                <div className="card-body text-center p-4">
                  <div className="bg-warning bg-opacity-10 rounded-circle d-inline-flex align-items-center justify-content-center mb-3" style={{ width: '80px', height: '80px' }}>
                    <FaChartLine className="text-warning fs-1" />
                  </div>
                  <h5 className="fw-bold mb-3">100% Job Support</h5>
                  <p className="text-muted">
                    Guaranteed placement assistance with top companies in your field and career guidance
                  </p>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      <style>{`
        .hover-card {
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }
        .hover-card:hover {
          transform: translateY(-10px);
          box-shadow: 0 10px 30px rgba(0,0,0,0.2) !important;
        }
        .form-select:focus,
        .form-control:focus {
          border-color: #667eea;
          box-shadow: 0 0 0 0.2rem rgba(102, 126, 234, 0.25);
        }
        .btn-primary {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          border: none;
        }
        .btn-primary:hover {
          background: linear-gradient(135deg, #764ba2 0%, #667eea 100%);
          transform: translateY(-2px);
          box-shadow: 0 5px 20px rgba(102, 126, 234, 0.4);
        }
      `}</style>
    </div>
  );
};

export default CompleteAcademyDashboard;